import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

let CustomColumnSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CUSTOM_COLUMN_ID',
        id_ui: 'DOMAIN_ID',
        name:  'DOMAIN_NAME'},

    searchProviderFields: {
        WB_CUSTOM_COLUMN_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
        TABLE_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Table Name', columnResourceName: 'colTableName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        COLUMN_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Column Name', columnResourceName: 'colColumnName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        COLUMN_DATATYPE: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Column Data Type', columnResourceName: 'colColumnDataType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        COLUMN_LENGTH: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Column Length', columnResourceName: 'colColumnLenght', alignment: HorizAlignment.Center}, domainOptions: { }},
        NOTES:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Notes', columnResourceName: 'colComments', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        }
    },


    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Custom_Column_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


let CustomColumnSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, TName, CName",
    renderOptions: { ui5ResourceId: "CustomColumnSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'WB_CUSTOM_COLUMN_ID', renderOptions: { }},
        {profileFilterName: 'TName',     searchProviderFieldId: 'TABLE_NAME', renderOptions: { }},
        {profileFilterName: 'CName',     searchProviderFieldId: 'COLUMN_NAME', renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'TABLE_NAME','COLUMN_NAME', 'COLUMN_DATATYPE', 'COLUMN_LENGHT', 'NOTES', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomColumnSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var CustomColumnSearch: ISearch = {
    searchName: "Find Custom Column",
    renderOptions: { ui5ResourceId: "CustomColumnSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CustomColumnSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("CustomColumnBO", "CustomColumn", CustomColumnSearch, "Custom Column Search")
export {CustomColumnSearch}